export default __webpack_public_path__ + "static/allstar-0cd214c0918219308984d18de20a729a.svg";